import React, { useState, useEffect, useRef, useMemo, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import FloatInput from "components/Input/FloatInput.js";
import TextInput from "components/Input/TextInput.js";
import IntInput from "components/Input/IntInput.js";
import DateInput from "components/Input/DateInput.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import UserService from "services/UserService";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";
import { batiment } from "variables/patrimoine.js";
import { makeStyles } from "@mui/styles";
import { getSite, getProfilePicture, getFiles, postFileUpload } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { NotificationManager } from 'react-notifications';
import Chip from "@mui/material/Chip";
import {
  statusData, activityData, subactivityData, constructionperiodData,
  structuretypeData, shapeData, periodData, conformeData
} from "variables/lists/patrimoine";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
    fontFamily: '"Source Sans Pro",sans-serif',

  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  textInput: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputImage: {
    display: "flex",
    flexDirection: "column",
    margin: "0rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: "12px",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function Activity(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [status, setStatus] = useState("");
  const [nafcode, setNafcode] = useState("");
  const [activitytype, setActivitytype] = useState("");
  const [activitysubtype, setActivitysubtype] = useState("");
  const [usage, setUsage] = useState("");
  const [usagecode, setUsageCode] = useState("");
  const [nontertiaryactivity, setNontertiaryactivity] = useState(false);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };
  const handleNafcodeChange = (event) => {
    setNafcode(event.target.value);
  };
  const handleActivitytypeChange = (event) => {
    setActivitytype(event.target.value);
  };
  const handleActivitysubtypeChange = (event) => {
    setActivitysubtype(event.target.value);
  };
  const handleUsageChange = (event) => {
    setUsage(event.target.value);
  };
  const handleUsageCodeChange = (event) => {
    setUsageCode(event.target.value);
  };
  const handleNontertiaryactivityChange = (event) => {
    setNontertiaryactivity(!nontertiaryactivity);
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.activity"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setStatus(res.data.detail.parameters?.activity?.status);
        setNafcode(res.data.detail.parameters?.activity?.nafcode);
        setActivitytype(res.data.detail.parameters?.activity?.activitytype);
        setActivitysubtype(res.data.detail.parameters?.activity?.activitysubtype);
        setUsage(res.data.detail.parameters?.activity?.usage);
        setUsageCode(res.data.detail.parameters?.activity?.usagecode);
        setNontertiaryactivity(res.data.detail.parameters?.activity?.nontertiaryactivity);
      })
      .catch(() => { });
  }, []);


  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.activity"),
        {
          status,
          nafcode,
          activitytype,
          activitysubtype,
          usage,
          usagecode,
          nontertiaryactivity,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();


  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <CustomSelect
              inputTitle={batiment.parameters.activity.status}
              selectValue={status}
              handleSelectValueChange={handleStatusChange}
              data={statusData}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.activity.nafcode}
              textInput={nafcode}
              handleTextInputChange={handleNafcodeChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={batiment.parameters.activity.activitytype}
              selectValue={activitytype}
              handleSelectValueChange={handleActivitytypeChange}
              data={activityData}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={batiment.parameters.activity.activitysubtype}
              selectValue={activitysubtype}
              handleSelectValueChange={handleActivitysubtypeChange}
              data={subactivityData[activitytype]}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.activity.usage}
              textInput={usage}
              handleTextInputChange={handleUsageChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.activity.usagecode}
              textInput={usagecode}
              handleTextInputChange={handleUsageCodeChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <CustomSwitch
              inputTitle={batiment.parameters.activity.nontertiaryactivity}
              checkedState={nontertiaryactivity}
              handleSwitchChange={handleNontertiaryactivityChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Dimension(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [shape, setShape] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [volume, setVolume] = useState("");
  const [surface, setSurface] = useState("");
  const [brutsurface, setBrutsurface] = useState("");
  const [heatedsurface, setHeatedsurface] = useState("");
  const [cooledsurface, setCooledsurface] = useState("");
  const [floorsurface, setFloorsurface] = useState("");
  const [shonsurface, setShonsurface] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleShapeChange = (event) => {
    setShape(event.target.value);
  };
  const handleLengthChange = (event) => {
    setLength(event.target.value);
  };
  const handleWidthChange = (event) => {
    setWidth(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleVolumeChange = (event) => {
    setVolume(event.target.value);
  };
  const handleSurfaceChange = (event) => {
    setSurface(event.target.value);
  };
  const handleBrutsurfaceChange = (event) => {
    setBrutsurface(event.target.value);
  };
  const handleHeatedsurfaceChange = (event) => {
    setHeatedsurface(event.target.value);
  };
  const handleCooledsurfaceChange = (event) => {
    setCooledsurface(event.target.value);
  };
  const handleFloorsurfaceChange = (event) => {
    setFloorsurface(event.target.value);
  };
  const handleShonsurfaceChange = (event) => {
    setShonsurface(event.target.value);
  };
  const handleCommentsChange = (event) => {
    setComments(event.target.value);
  };
  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.dimension"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setShape(res.data.detail.parameters?.dimension?.shape);
        setLength(res.data.detail.parameters?.dimension?.length);
        setWidth(res.data.detail.parameters?.dimension?.width);
        setHeight(res.data.detail.parameters?.dimension?.height);
        setVolume(res.data.detail.parameters?.dimension?.volume);
        setSurface(res.data.detail.parameters?.dimension?.surface);
        setBrutsurface(res.data.detail.parameters?.dimension?.brutsurface);
        setHeatedsurface(res.data.detail.parameters?.dimension?.heatedsurface);
        setCooledsurface(res.data.detail.parameters?.dimension?.cooledsurface);
        setFloorsurface(res.data.detail.parameters?.dimension?.floorsurface);
        setShonsurface(res.data.detail.parameters?.dimension?.shonsurface);
        setComments(res.data.detail.parameters?.dimension?.comments);
        setDescription(res.data.detail.parameters?.dimension?.description);
      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.dimension"),
        {
          shape,
          length,
          width,
          height,
          volume,
          surface,
          brutsurface,
          heatedsurface,
          cooledsurface,
          floorsurface,
          shonsurface,
          comments,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };



  const classes = useStyles();
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <CustomSelect
              inputTitle={batiment.parameters.dimension.shape}
              selectValue={shape}
              handleSelectValueChange={handleShapeChange}
              data={shapeData}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.length}
              intInput={length}
              handleIntInputChange={handleLengthChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.width}
              intInput={width}
              handleIntInputChange={handleWidthChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.height}
              intInput={height}
              handleIntInputChange={handleHeightChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.volume}
              intInput={volume}
              handleIntInputChange={handleVolumeChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.surface}
              intInput={surface}
              handleIntInputChange={handleSurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.brutsurface}
              intInput={brutsurface}
              handleIntInputChange={handleBrutsurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.heatedsurface}
              intInput={heatedsurface}
              handleIntInputChange={handleHeatedsurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.cooledsurface}
              intInput={cooledsurface}
              handleIntInputChange={handleCooledsurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.floorsurface}
              intInput={floorsurface}
              handleIntInputChange={handleFloorsurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.dimension.shonsurface}
              intInput={shonsurface}
              handleIntInputChange={handleShonsurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.dimension.comments}
              textInput={comments}
              handleTextInputChange={handleCommentsChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.dimension.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Occupation(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [occupancycountperiode, setOccupancycountperiode] = useState("");
  const [occupancycountvalue, setOccupancycountvalue] = useState("");
  const [maximalcapacity, setMaximalcapacity] = useState("");
  const [averageoccupancy, setAverageoccupancy] = useState("");
  const [occupancytimeperiode, setOccupancytimeperiode] = useState("");
  const [occupancytimevalue, setOccupancytimevalue] = useState("");
  const [occupancycomments, setOccupancycomments] = useState("");
  const [mondayschedulestart, setMondayschedulestart] = useState("");
  const [tuesdayschedulestart, setTuesdayschedulestart] = useState("");
  const [wednesdayschedulestart, setWednesdayschedulestart] = useState("");
  const [thursdayschedulestart, setThursdayschedulestart] = useState("");
  const [fridayschedulestart, setFridayschedulestart] = useState("");
  const [saturdayschedulestart, setSaturdayschedulestart] = useState("");
  const [sundayschedulestart, setSundayschedulestart] = useState("");
  const [mondayscheduleend, setMondayscheduleend] = useState("");
  const [tuesdayscheduleend, setTuesdayscheduleend] = useState("");
  const [wednesdayscheduleend, setWednesdayscheduleend] = useState("");
  const [thursdayscheduleend, setThursdayscheduleend] = useState("");
  const [fridayscheduleend, setFridayscheduleend] = useState("");
  const [saturdayscheduleend, setSaturdayscheduleend] = useState("");
  const [sundayscheduleend, setSundayscheduleend] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");


  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleOccupancycountperiodeChange = (event) => { setOccupancycountperiode(event.target.value); };
  const handleOccupancycountvalueChange = (event) => { setOccupancycountvalue(event.target.value); };
  const handleMaximalcapacityChange = (event) => { setMaximalcapacity(event.target.value); };
  const handleAverageoccupancyChange = (event) => { setAverageoccupancy(event.target.value); };
  const handleOccupancytimeperiodeChange = (event) => { setOccupancytimeperiode(event.target.value); };
  const handleOccupancytimevalueChange = (event) => { setOccupancytimevalue(event.target.value); };
  const handleMondayschedulestartChange = (event) => { setMondayschedulestart(event.target.value); };
  const handleTuesdayschedulestartChange = (event) => { setTuesdayschedulestart(event.target.value); };
  const handleWednesdayschedulestartChange = (event) => { setWednesdayschedulestart(event.target.value); };
  const handleThursdayschedulestartChange = (event) => { setThursdayschedulestart(event.target.value); };
  const handleFridayschedulestartChange = (event) => { setFridayschedulestart(event.target.value); };
  const handleSaturdayschedulestartChange = (event) => { setSaturdayschedulestart(event.target.value); };
  const handleSundayschedulestartChange = (event) => { setSundayschedulestart(event.target.value); };
  const handleMondayscheduleendChange = (event) => { setMondayscheduleend(event.target.value); };
  const handleTuesdayscheduleendChange = (event) => { setTuesdayscheduleend(event.target.value); };
  const handleWednesdayscheduleendChange = (event) => { setWednesdayscheduleend(event.target.value); };
  const handleThursdayscheduleendChange = (event) => { setThursdayscheduleend(event.target.value); };
  const handleFridayscheduleendChange = (event) => { setFridayscheduleend(event.target.value); };
  const handleSaturdayscheduleendChange = (event) => { setSaturdayscheduleend(event.target.value); };
  const handleSundayscheduleendChange = (event) => { setSundayscheduleend(event.target.value); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };


  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.occupation"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setOccupancycountperiode(res.data.detail.parameters?.occupation?.occupancycountperiode);
        setOccupancycountvalue(res.data.detail.parameters?.occupation?.occupancycountvalue);
        setMaximalcapacity(res.data.detail.parameters?.occupation?.maximalcapacity);
        setAverageoccupancy(res.data.detail.parameters?.occupation?.averageoccupancy);
        setOccupancytimeperiode(res.data.detail.parameters?.occupation?.occupancytimeperiode);
        setOccupancytimevalue(res.data.detail.parameters?.occupation?.occupancytimevalue);
        setOccupancycomments(res.data.detail.parameters?.occupation?.occupancycomments);
        setMondayschedulestart(res.data.detail.parameters?.occupation?.mondayschedulestart);
        setTuesdayschedulestart(res.data.detail.parameters?.occupation?.tuesdayschedulestart);
        setWednesdayschedulestart(res.data.detail.parameters?.occupation?.wednesdayschedulestart);
        setThursdayschedulestart(res.data.detail.parameters?.occupation?.thursdayschedulestart);
        setFridayschedulestart(res.data.detail.parameters?.occupation?.fridayschedulestart);
        setSaturdayschedulestart(res.data.detail.parameters?.occupation?.saturdayschedulestart);
        setSundayschedulestart(res.data.detail.parameters?.occupation?.sundayschedulestart);
        setMondayscheduleend(res.data.detail.parameters?.occupation?.mondayscheduleend);
        setTuesdayscheduleend(res.data.detail.parameters?.occupation?.tuesdayscheduleend);
        setWednesdayscheduleend(res.data.detail.parameters?.occupation?.wednesdayscheduleend);
        setThursdayscheduleend(res.data.detail.parameters?.occupation?.thursdayscheduleend);
        setFridayscheduleend(res.data.detail.parameters?.occupation?.fridayscheduleend);
        setSaturdayscheduleend(res.data.detail.parameters?.occupation?.saturdayscheduleend);
        setSundayscheduleend(res.data.detail.parameters?.occupation?.sundayscheduleend);
        setComments(res.data.detail.parameters?.occupation?.comments);
        setDescription(res.data.detail.parameters?.occupation?.description);

      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.occupation"),
        {
          occupancycountperiode,
          occupancycountvalue,
          maximalcapacity,
          averageoccupancy,
          occupancytimeperiode,
          occupancytimevalue,
          occupancycomments,
          mondayschedulestart,
          tuesdayschedulestart,
          wednesdayschedulestart,
          thursdayschedulestart,
          fridayschedulestart,
          saturdayschedulestart,
          sundayschedulestart,
          mondayscheduleend,
          tuesdayscheduleend,
          wednesdayscheduleend,
          thursdayscheduleend,
          fridayscheduleend,
          saturdayscheduleend,
          sundayscheduleend,
          comments,
          description,

        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };



  const classes = useStyles();
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <CustomSelect
              inputTitle={batiment.parameters.occupation.occupancycountperiode}
              selectValue={occupancycountperiode}
              handleSelectValueChange={handleOccupancycountperiodeChange}
              data={periodData}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.occupation.occupancycountvalue}
              intInput={occupancycountvalue}
              handleIntInputChange={handleOccupancycountvalueChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.occupation.maximalcapacity}
              intInput={maximalcapacity}
              handleIntInputChange={handleMaximalcapacityChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={batiment.parameters.occupation.averageoccupancy}
              floatInput={averageoccupancy}
              handleFloatInputChange={handleAverageoccupancyChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={batiment.parameters.occupation.occupancytimeperiode}
              selectValue={occupancytimeperiode}
              handleSelectValueChange={handleOccupancytimeperiodeChange}
              data={periodData}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.occupation.occupancytimevalue}
              intInput={occupancytimevalue}
              handleIntInputChange={handleOccupancytimevalueChange}
              disabled={!realestateupdate}
            />
          </div>
          <GridContainer>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.mondayschedulestart}
                  dateInput={mondayschedulestart}
                  handleDateInputChange={handleMondayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.mondayscheduleend}
                  dateInput={mondayscheduleend}
                  handleDateInputChange={handleMondayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.tuesdayschedulestart}
                  dateInput={tuesdayschedulestart}
                  handleDateInputChange={handleTuesdayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.tuesdayscheduleend}
                  dateInput={tuesdayscheduleend}
                  handleDateInputChange={handleTuesdayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.wednesdayschedulestart}
                  dateInput={wednesdayschedulestart}
                  handleDateInputChange={handleWednesdayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.wednesdayscheduleend}
                  dateInput={wednesdayscheduleend}
                  handleDateInputChange={handleWednesdayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.thursdayschedulestart}
                  dateInput={thursdayschedulestart}
                  handleDateInputChange={handleThursdayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.thursdayscheduleend}
                  dateInput={thursdayscheduleend}
                  handleDateInputChange={handleThursdayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.fridayschedulestart}
                  dateInput={fridayschedulestart}
                  handleDateInputChange={handleFridayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.fridayscheduleend}
                  dateInput={fridayscheduleend}
                  handleDateInputChange={handleFridayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.saturdayschedulestart}
                  dateInput={saturdayschedulestart}
                  handleDateInputChange={handleSaturdayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.saturdayscheduleend}
                  dateInput={saturdayscheduleend}
                  handleDateInputChange={handleSaturdayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.sundayschedulestart}
                  dateInput={sundayschedulestart}
                  handleDateInputChange={handleSundayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.sundayscheduleend}
                  dateInput={sundayscheduleend}
                  handleDateInputChange={handleSundayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
          </GridContainer>
          <div>
            <TextInput
              inputTitle={batiment.parameters.occupation.comments}
              textInput={comments}
              handleTextInputChange={handleCommentsChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.occupation.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Properties(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [lastaudit, setLastaudit] = useState("");
  const [performancegrade, setPerformancegrade] = useState("");
  const [performancecomment, setPerformancecomment] = useState("");
  const [dilapidationgrade, setDilapidationgrade] = useState("");
  const [dilapidationcomment, setDilapidationcomment] = useState("");
  const [architecturalconstraints, setArchitecturalconstraints] = useState(false);
  const [architecturalconstraintscomment, setArchitecturalconstraintscomment] = useState("");
  const [boilerroomcompliance, setBoilerroomcompliance] = useState("");
  const [boilerroomcompliancecomment, setBoilerroomcompliancecomment] = useState("");
  const [feedback, setFeedback] = useState("");
  const [lastrehabilitation, setLastrehabilitation] = useState("");
  const [rehabilitationtype, setRehabilitationtype] = useState("");
  const [nextrehabilitation, setNextrehabilitation] = useState("");
  const [certification, setCertification] = useState("");
  const [internetaccess, setInternetaccess] = useState(false);
  const [otherproperties, setOtherproperties] = useState([]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleLastauditChange = (event) => { setLastaudit(event.target.value); };
  const handlePerformancegradeChange = (event) => { setPerformancegrade(event.target.value); };
  const handlePerformancecommentChange = (event) => { setPerformancecomment(event.target.value); };
  const handleDilapidationgradeChange = (event) => { setDilapidationgrade(event.target.value); };
  const handleDilapidationcommentChange = (event) => { setDilapidationcomment(event.target.value); };
  const handleArchitecturalconstraintsChange = (event) => { setArchitecturalconstraints(!architecturalconstraints); };
  const handleArchitecturalconstraintscommentChange = (event) => { setArchitecturalconstraintscomment(event.target.value); };
  const handleBoilerroomcomplianceChange = (event) => { setBoilerroomcompliance(event.target.value); };
  const handleBoilerroomcompliancecommentChange = (event) => { setBoilerroomcompliancecomment(event.target.value); };
  const handleFeedbackChange = (event) => { setFeedback(event.target.value); };
  const handleLastrehabilitationChange = (event) => { setLastrehabilitation(event.target.value); };
  const handleRehabilitationtypeChange = (event) => { setRehabilitationtype(event.target.value); };
  const handleNextrehabilitationChange = (event) => { setNextrehabilitation(event.target.value); };
  const handleCertificationChange = (event) => { setCertification(event.target.value); };
  const handleInternetaccessChange = (event) => { setInternetaccess(!internetaccess); };
  const handleOtherpropertiesChange = (newValue) => {
    setOtherproperties(newValue);
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.properties"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setLastaudit(res.data.detail.parameters?.properties?.lastaudit);
        setPerformancegrade(res.data.detail.parameters?.properties?.performancegrade);
        setPerformancecomment(res.data.detail.parameters?.properties?.performancecomment);
        setDilapidationgrade(res.data.detail.parameters?.properties?.dilapidationgrade);
        setDilapidationcomment(res.data.detail.parameters?.properties?.dilapidationcomment);
        setArchitecturalconstraints(res.data.detail.parameters?.properties?.architecturalconstraints);
        setArchitecturalconstraintscomment(res.data.detail.parameters?.properties?.architecturalconstraintscomment);
        setBoilerroomcompliance(res.data.detail.parameters?.properties?.boilerroomcompliance);
        setBoilerroomcompliancecomment(res.data.detail.parameters?.properties?.boilerroomcompliancecomment);
        setFeedback(res.data.detail.parameters?.properties?.feedback);
        setLastrehabilitation(res.data.detail.parameters?.properties?.lastrehabilitation);
        setRehabilitationtype(res.data.detail.parameters?.properties?.rehabilitationtype);
        setNextrehabilitation(res.data.detail.parameters?.properties?.nextrehabilitation);
        setCertification(res.data.detail.parameters?.properties?.certification);
        setInternetaccess(res.data.detail.parameters?.properties?.internetaccess);
        setOtherproperties(res.data.detail.parameters?.properties?.otherproperties || []);
      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.properties"),
        {
          lastaudit,
          performancegrade,
          performancecomment,
          dilapidationgrade,
          dilapidationcomment,
          architecturalconstraints,
          architecturalconstraintscomment,
          boilerroomcompliance,
          boilerroomcompliancecomment,
          feedback,
          lastrehabilitation,
          rehabilitationtype,
          nextrehabilitation,
          certification,
          internetaccess,
          otherproperties,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };



  const autocompleteOptions = [];
  const classes = useStyles();
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <DateInput
              inputTitle={batiment.parameters.properties.lastaudit}
              dateInput={lastaudit}
              handleDateInputChange={handleLastauditChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.properties.performancegrade}
              textInput={performancegrade}
              handleTextInputChange={handlePerformancegradeChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.properties.performancecomment}
              textInput={performancecomment}
              handleTextInputChange={handlePerformancecommentChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.properties.dilapidationgrade}
              textInput={dilapidationgrade}
              handleTextInputChange={handleDilapidationgradeChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.properties.dilapidationcomment}
              textInput={dilapidationcomment}
              handleTextInputChange={handleDilapidationcommentChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <CustomSwitch
              inputTitle={batiment.parameters.properties.architecturalconstraints}
              checkedState={architecturalconstraints}
              handleSwitchChange={handleArchitecturalconstraintsChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.properties.architecturalconstraintscomment}
              textInput={architecturalconstraintscomment}
              handleTextInputChange={handleArchitecturalconstraintscommentChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={batiment.parameters.properties.boilerroomcompliance}
              selectValue={boilerroomcompliance}
              handleSelectValueChange={handleBoilerroomcomplianceChange}
              disabled={!realestateupdate}
              data={conformeData}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.properties.boilerroomcompliancecomment}
              textInput={boilerroomcompliancecomment}
              handleTextInputChange={handleBoilerroomcompliancecommentChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <AutocompleteTagsInput
              inputTitle={batiment.parameters.properties.otherproperties}
              list={autocompleteOptions}
              selected={otherproperties}
              handleChange={handleOtherpropertiesChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.properties.feedback}
              textInput={feedback}
              handleTextInputChange={handleFeedbackChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <DateInput
              inputTitle={batiment.parameters.properties.lastrehabilitation}
              dateInput={lastrehabilitation}
              handleDateInputChange={handleLastrehabilitationChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.properties.rehabilitationtype}
              textInput={rehabilitationtype}
              handleTextInputChange={handleRehabilitationtypeChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <DateInput
              inputTitle={batiment.parameters.properties.nextrehabilitation}
              dateInput={nextrehabilitation}
              handleDateInputChange={handleNextrehabilitationChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.properties.certification}
              textInput={certification}
              handleTextInputChange={handleCertificationChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <CustomSwitch
              inputTitle={batiment.parameters.properties.internetaccess}
              checkedState={internetaccess}
              handleSwitchChange={handleInternetaccessChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Other(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [associatedfiles, setAssociatedfiles] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleAssociatedfilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociatedfiles(newArray);
  };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.other"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setAssociatedfiles(res.data.detail.parameters?.other?.associatedfiles || []);
        setComments(res.data.detail.parameters?.other?.comments);
        setDescription(res.data.detail.parameters?.other?.description);
      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.other"),
        {
          associatedfiles,
          comments,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <AutocompleteInput
              disabled={!realestateupdate}
              inputTitle={batiment.parameters.other.associatedfiles}
              selected={selectedGed()}
              list={gedList}
              handleChange={(_, newValue) =>
                handleAssociatedfilesChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.other.comments}
              textInput={comments}
              handleTextInputChange={handleCommentsChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.other.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Parameters(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [imageUrl, setImageUrl] = useState(null);
  const [imageCode, setImageCode] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);

  const [clef, setClef] = useState("");

  const [localization, setLocalization] = useState(null);
  const [localizationValue, setLocalizationValue] = useState("");
  const [options, setOptions] = useState([]);
  const [validatedAddress, setValidatedAddress] = useState({});
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [siret, setSiret] = useState("");
  const [siren, setSiren] = useState("");
  const [nic, setNic] = useState("");
  const [floorcount, setFloorcount] = useState("");
  const [roomcount, setRoomcount] = useState("");
  const [constructionyear, setConstructionyear] = useState("");
  const [constructionperiod, setConstructionperiod] = useState("");
  const [commissioningyear, setCommissioningyear] = useState("");
  const [structuretype, setStructuretype] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const loaded = useRef(false);

  const handleClefChange = (event) => { setClef(event.target.value); };
  const handleSiretChange = (event) => { setSiret(event.target.value); };
  const handleSirenChange = (event) => { setSiren(event.target.value); };
  const handleNicChange = (event) => { setNic(event.target.value); };
  const handleFloorcountChange = (event) => { setFloorcount(event.target.value); };
  const handleRoomcountChange = (event) => { setRoomcount(event.target.value); };
  const handleConstructionyearChange = (event) => { setConstructionyear(event.target.value); };
  const handleConstructionperiodChange = (event) => { setConstructionperiod(event.target.value); };
  const handleCommissioningyearChange = (event) => { setCommissioningyear(event.target.value); };
  const handleStructuretypeChange = (event) => { setStructuretype(event.target.value); };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.parameters"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setClef(res.data.detail.parameters?.parameters?.clef || "");
        setLocalization(res.data.detail.parameters?.parameters?.localization);
        setValidatedAddress(res.data.detail.parameters?.parameters?.validatedAddress)
        setSiret(res.data.detail.parameters?.parameters?.siret);
        setSiren(res.data.detail.parameters?.parameters?.siren);
        setNic(res.data.detail.parameters?.parameters?.nic);
        setFloorcount(res.data.detail.parameters?.parameters?.floorcount);
        setRoomcount(res.data.detail.parameters?.parameters?.roomcount);
        setConstructionyear(res.data.detail.parameters?.parameters?.constructionyear);
        setConstructionperiod(res.data.detail.parameters?.parameters?.constructionperiod);
        setCommissioningyear(res.data.detail.parameters?.parameters?.commissioningyear);
        setStructuretype(res.data.detail.parameters?.parameters?.structuretype);
        setEmail(res.data.detail.parameters?.parameters?.email);
        setPhone(res.data.detail.parameters?.parameters?.phone);
        let imageCode = res.data.detail.parameters?.parameters?.imageCode;
        if (imageCode) {
          setImageCode(imageCode);
          setImagePreviewUrl(
            getProfilePicture(imageCode)
          );
        }
      })
      .catch(() => { });
  }, []);

  //Profile picture
  useEffect(() => {
    if (imageUrl) {
      const formData = new FormData();
      // we append each element to the form
      formData.append("files", imageUrl);
      axios
        .post(
          postFileUpload(chartIdGroup, "profilepic"),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setImageCode(res.data.files[0].url);
          setImagePreviewUrl(
            getProfilePicture(res.data.files[0].url)
          );
        })
        .catch(() => { });
    }
  }, [imageUrl]);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.parameters"),
        {
          imageCode,
          clef,
          localization,
          validatedAddress,
          siret,
          siren,
          nic,
          floorcount,
          roomcount,
          constructionyear,
          constructionperiod,
          commissioningyear,
          structuretype,
          email,
          phone,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();


  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <div className={classes.inputImage}>
              <div className={classes.inputTitle}>
                {batiment.parameters.parameters.picture}
              </div>
              <ImageUpload
                disabled={!realestateupdate}
                file={imageUrl}
                setImageCode={setImageCode}
                setFile={setImageUrl}
                imagePreviewUrl={imagePreviewUrl}
                setImagePreviewUrl={setImagePreviewUrl}
              />
            </div>
          </div>

          <div>
            <TextInput
              inputTitle={batiment.parameters.parameters.key}
              textInput={clef}
              handleTextInputChange={handleClefChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <LocalizationAutocomplete
              inputTitle={batiment.parameters.parameters.address}
              value={localization}
              setValue={setLocalization}
              inputValue={localizationValue}
              setInputValue={setLocalizationValue}
              options={options}
              setOptions={setOptions}
              setValidatedAddress={setValidatedAddress}
              validatedAddress={validatedAddress}
              loaded={loaded}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.parameters.email}
              textInput={email}
              handleTextInputChange={handleEmailChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <TextInput
              inputTitle={batiment.parameters.parameters.phone}
              textInput={phone}
              handleTextInputChange={handlePhoneChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.parameters.siret}
              textInput={siret}
              handleTextInputChange={handleSiretChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.parameters.siren}
              textInput={siren}
              handleTextInputChange={handleSirenChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.parameters.nic}
              textInput={nic}
              handleTextInputChange={handleNicChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.parameters.floorcount}
              intInput={floorcount}
              handleIntInputChange={handleFloorcountChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.parameters.roomcount}
              intInput={roomcount}
              handleIntInputChange={handleRoomcountChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <DateInput
              inputTitle={batiment.parameters.parameters.constructionyear}
              dateInput={constructionyear}
              handleDateInputChange={handleConstructionyearChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <CustomSelect
              inputTitle={batiment.parameters.parameters.constructionperiod}
              selectValue={constructionperiod}
              handleSelectValueChange={handleConstructionperiodChange}
              data={constructionperiodData}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <DateInput
              inputTitle={batiment.parameters.parameters.commissioningyear}
              dateInput={commissioningyear}
              handleDateInputChange={handleCommissioningyearChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <CustomSelect
              inputTitle={batiment.parameters.parameters.structuretype}
              selectValue={structuretype}
              handleSelectValueChange={handleStructuretypeChange}
              disabled={!realestateupdate}
              data={structuretypeData}
            />
          </div>
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export { Activity, Dimension, Occupation, Properties, Other, Parameters };
